export const ID_VETERINARIO_OFICIAL = 5;
